$(document).ready(function () {
    function getNextWeekday(date) {
        // Increment date until it is not Sunday (0)
        while (date.getDay() === 0) {
            date.setDate(date.getDate() + 1);
        }
        return date;
    }

    function getAdjustedDate(baseDate, daysToAdd, allowSaturday = false) {
        let newDate = new Date(baseDate);
        while (daysToAdd > 0) {
            newDate.setDate(newDate.getDate() + 1);
            if (newDate.getDay() !== 0 && (allowSaturday || newDate.getDay() !== 6)) {
                // Only decrement daysToAdd for weekdays or Saturdays (if allowed)
                daysToAdd--;
            }
        }
        return newDate;
    }

    function ordinal_suffix_of(i) {
        let j = i % 10,
            k = i % 100;
        return j == 1 && k != 11
            ? i + "st"
            : j == 2 && k != 12
            ? i + "nd"
            : j == 3 && k != 13
            ? i + "rd"
            : i + "th";
    }

    const today = new Date();
    const currentTime = today.getHours();
    const oneDay = 1; // Using 1 day as increment
    const baseDate = currentTime >= 17 ? getNextWeekday(new Date(today.getTime() + 24 * 60 * 60 * 1000)) : today;

    // Allow Saturday for day1
    const firstDay = getAdjustedDate(baseDate, oneDay, true);
    const secondDay = getAdjustedDate(baseDate, 2);
    const thirdDay = getAdjustedDate(baseDate, 3);
    const forthDay = getAdjustedDate(baseDate, 6);
    const twelfthDay = getAdjustedDate(baseDate, 12);

    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    console.log(baseDate)
    console.log(firstDay)

    const firstHTML = `<span>${weekday[firstDay.getDay()]}, ${firstDay.toLocaleString("default", { month: "long" })} ${ordinal_suffix_of(firstDay.getDate())}</span>`;
    const secondHTML = `<span>${weekday[secondDay.getDay()]}, ${secondDay.toLocaleString("default", { month: "long" })} ${ordinal_suffix_of(secondDay.getDate())}</span>`;
    const thirdHTML = `<span>${weekday[thirdDay.getDay()]}, ${thirdDay.toLocaleString("default", { month: "long" })} ${ordinal_suffix_of(thirdDay.getDate())}</span>`;
    const forthHTML = `<span>${weekday[forthDay.getDay()]}, ${forthDay.toLocaleString("default", { month: "long" })} ${ordinal_suffix_of(forthDay.getDate())}</span>`;
    const twelfthHTML = `Estimated delivery by <span>${weekday[twelfthDay.getDay()]}, ${twelfthDay.toLocaleString("default", { month: "long" })} ${ordinal_suffix_of(twelfthDay.getDate())}</span>`;

    $(".day1").html(firstHTML);
    $(".day2").html(secondHTML);
    $(".day3").html(thirdHTML);
    $(".day4").html(forthHTML);
});


$(function(){
  $('.faq-btn').on('click', function(e){
    e.preventDefault();
    $('.faq-container').slideToggle();
  });

  $('.common_faq-item__title').on('click', function(){
    if($(window).width() < 750){
      $(this).parent().find('.common_faq-item__description').slideToggle(500);
      $(this).parent().addClass('close');
    }
  });

  $('.faq-item .faq-item__title').on('click', function() {
    if($(this).parent().hasClass('open')){
      $(this).parent().find('.faq-item__description').slideUp(500);
      $(this).parent().removeClass('open');
    }else{
      $('.faq-item .faq-item__description').slideUp();
      $('.faq-item').removeClass('open');
      $(this).parent().find('.faq-item__description').slideToggle(500);
      $(this).parent().addClass('open');
    }
  });

  $(document).on('click', '.product-form__input.product-form__input--dropdown.product-form__input--dropdown-color .color-swatch', function(e) {
    e.preventDefault();

    var val = $(this).data('value');
    var id = $(this).data('id');
    $('.product-form__input.product-form__input--dropdown.product-form__input--dropdown-color .color-swatch').removeClass('selected');
    $(this).addClass('selected');

    var select = document.getElementById(id);
    $(select).val(val).change();

    // Find the VariantSelects instance and call onVariantChange
    var variantSelects = document.querySelector('variant-selects'); // Adjust selector if needed
    if (variantSelects && variantSelects.onVariantChange) {
        variantSelects.onVariantChange.call(variantSelects);
    }
});

  var bundleSelect = function($element, $behaviour){
    var productTitle = $element.find('.card-title').text();
    var rawPrice = 0;
    var price = $element.find('.card-price').attr('data-price');
    var dataId = $element.attr('data-product-id');
    var quantity = 1;
    if($element.find('input.quantity__input').length){
      quantity = $element.find('input.quantity__input').val();
    }
    //console.log(quantity);
    var itemTotalPrice = parseFloat(price)*quantity;
    itemTotalPrice = '$' + parseFloat(itemTotalPrice / 100).toFixed(2);
    var productVatiantTitle = $element.attr('data-variant-title');
    //console.log(productVatiantTitle)
    $('.variant-products .grid__item.selected').each(function(){
      let qty = 1;
      if($(this).find('input.quantity__input').length){
        qty = $(this).find('input.quantity__input').val();
      }
      let itemPrice = parseFloat($(this).find('.card-price').attr('data-price')) * qty;
      rawPrice += itemPrice;
    });    
    var liHtml = 
      `<li class="bundle-total-item" data-id="${dataId}">
        <div class="bundle-total-item-title">${productTitle} - ${productVatiantTitle}</div>
        <div class="bundle-total-item-price">${itemTotalPrice}</div>
      <li>`;
    var totalPrice = '$' + parseFloat(rawPrice / 100).toFixed(2);
    if($(`.products-total-bundle .bundle-total-item[data-id=${dataId}]`).length){
      if($behaviour == 'modify'){
        $(`.products-total-bundle .bundle-total-item[data-id=${dataId}] .bundle-total-item-price`).text(itemTotalPrice);
        $(`.products-total-bundle .bundle-total-item[data-id=${dataId}] .bundle-total-item-title`).text(`${productTitle} - ${productVatiantTitle}`);
      }else{
        $(`.products-total-bundle .bundle-total-item[data-id=${dataId}]`).remove();
      }
    }else{
      $('.products-total-bundle').append(liHtml);
    }
    $('.all-total-amount').text(totalPrice);
  };

  $('.products-bundle .bundle-item').on('click', function(e){
    if( $(e.target).closest(".select__select").length ){
		return false;
	}
    $(this).toggleClass('selected');
    bundleSelect($(this), 'addremove');
  });

  $('.accessories-item .quick-add__btn').on('click', function(){
    var $this = $(this);
    var id = $this.parents('.accessories-item').data('id');
    var qty = $this.parent().find('.quantity__input').val();
    console.log(id);
    
    if($this.parents('.accessories-item').hasClass('selected')){
      $this.parents('.accessories-item').removeClass('selected');
      $this.find('.btn-lbl').text('ADD');
      $.ajax({
      type:"post",
      dataType: "json",
      url: '/cart/change.js',
      data:{quantity:qty,id:id},
      success: function(data){
         console.log(id);
      }
    });
    }else{
      $this.parents('.accessories-item').addClass('selected');
      $this.addClass('loading');
      $this.find('.loading-overlay__spinner').removeClass('hidden');
      setTimeout(function(){ 
        $this.removeClass('loading');
        $this.find('.loading-overlay__spinner').addClass('hidden');
        $this.find('.btn-lbl').text('REMOVE');
        $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:{quantity:qty,id:id},
        success: function(data){
           console.log(id);
        }
      });
      }, 1000);
    }
    bundleSelect($this.parents('.accessories-item'), 'addremove');
  });

  $('.products-bundle .bundle-item .select__select').on('change', function(){
    var $this = $(this);
    if($this.val() != ""){
      var selected_variant_id = $(this).val();
      var variantPrice = '';
      var variantTitle = "";
      var variantsData =  $.parseJSON($(this).parents('.products-bundle .bundle-item').attr('data-variant'));
      $(this).parents('.products-bundle .bundle-item').attr('data-id', selected_variant_id);
      //console.log(variantsData);
      $.each(variantsData, function(index, variant) {
        if(variant.id == selected_variant_id){
          variantPrice = variant.price ;
          variantTitle = variant.title;
        }
      });
      var variantFormattedPrice = '$' + (variantPrice / 100);
      var variantTitleArray = variantTitle.split(" ");
      var variantPerPiece = '$'+ parseFloat((variantPrice / variantTitleArray[0])/100).toFixed(2) + '/pc';
      //console.log(variantPerPiece);
      $this.parents('.products-bundle .bundle-item').find('.card-price').text(variantFormattedPrice);
      $this.parents('.products-bundle .bundle-item').find('.card-price').attr('data-price',variantPrice);
      $this.parents('.products-bundle .bundle-item').find('.card-per-price').text(variantPerPiece);
      $this.parents('.products-bundle .bundle-item').attr('data-variant-title', variantTitle);
      
      if(!$this.parents('.products-bundle .bundle-item').hasClass('selected')){
        $this.parents('.products-bundle .bundle-item').addClass('selected');
      }
      bundleSelect($this.parents('.products-bundle .bundle-item'), 'modify');
    }else{
      $this.parents('.products-bundle .bundle-item').removeClass('selected');
      bundleSelect($this.parents('.products-bundle .bundle-item'), 'addremove');
    }
  });

  $('.custom-addto-cart').on('click', function(){

    $('.addtocart-wrapper .custom-addto-cart-default').trigger('click');
    
    // if(!$('.products-bundle .bundle-item.selected').length){
    //   $('html, body').animate({
    //     scrollTop: $(".product-bundle-container").offset().top
    //   }, 2000);
    //   return false;
    // }
    // var items = [];
    // var formData = {};
    // $(this).addClass('loading');
    // $(this).find('.loading-overlay__spinner').removeClass('hidden');
    // $('.variant-products .grid__item.selected').each(function(){
    //   var item = {}
    //   item["id"] = $(this).attr('data-id');
    //   item["quantity"] = $(this).find('input[name="quantity"]').val();
    //   items.push(item);
    // });
    // formData['items'] = items;
    
    // jQuery.post('/cart/add.js', formData, function(){
    //   window.location.href = "/cart";
    // });

    
    
  });
  
  $('.custom-addto-cart-default').on('click', function(){
    var items = [];
    var formData = {};
    $(this).addClass('loading');
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    var mainProduct = {};
    mainProduct["id"] = $('[data-type="add-to-cart-form"]').find('input[name="id"]').val();
    mainProduct["quantity"] = $('.product-info-top').find('input.quantity__input').val();
    console.log(mainProduct);
    items.push(mainProduct);
    // $('.variant-products .grid__item.selected').each(function(){
    //   var item = {};
    //   item["id"] = $(this).attr('data-id');
    //   item["quantity"] = $(this).find('input[name="quantity"]').val();
    //   items.push(item);
    // });
    console.log(items);
    formData['items'] = items;
    
    jQuery.post('/cart/add.js', formData, function(){
      //window.location.href = "/cart";
    });
    setTimeout(function(){
       $(this).removeClass('loading');
    },1000)
  });
  
  $('.mobile-description .description-heading').on('click', function(){
     $(this).parent().find('.product__description').slideToggle(500);
  });

  var announcementSlider = function() {
    var play = $('.announcement-bar-Slider-new').attr('data-autoplay');
    var speed = $('.announcement-bar-Slider-new').attr('data-speed')*1000;
     $('.announcement-bar-Slider-new').flickity({
      // options
       cellAlign: 'left',
       groupCells: true,
       wrapAround: false,
       prevNextButtons: false,
       pageDots: false, 
       autoPlay: play,
       autoPlay: speed,
       pauseAutoPlayOnHover: false
    });
   
  };

  var swiper = new Swiper(".review_slider", {
    slidesPerView: 1.1,
    spaceBetween: 20, 
    loop: true,
    navigation: {
    nextEl: ".review-next",
    prevEl: ".review-prev",
  },
   breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,

    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 40,
    },
    1200: {
      slidesPerView: 3.8,
      spaceBetween: 30,
    },
  },
});
   
var swiper = new Swiper(".multi_img_slider", {
    slidesPerView: 1.2,
    spaceBetween: 20, 
    loop: true,
    pagination: {
        el: ".multi_img-pagination",
        clickable: true,
  },
   breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,

    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 4.5,
      spaceBetween: 30,
    },
  },
});
  var featuredBannerslide = new Swiper(".featured_banner_slide", {
    slidesPerView: 1.1,
    spaceBetween: 0, 
    loop: true,
    pagination: {
        el: ".swiper-pagination.multi_img-pagination",
        clickable: true,
  },
   breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,

    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 4.5,
      spaceBetween: 30,
    },
  },
});
  announcementSlider();
  if( $('.featured_banner_slide').length > 0 ){featuredBannerslide();}

  $(document).on('shopify:section:load', function(event) { 
    announcementSlider();
    if( $('.featured_banner_slide').length > 0 ){featuredBannerslide();}
  });
  
});

 var protectionCheckbox = $('#shipping-protection-toggle');
    var protectionVariantId = protectionCheckbox.val();
    
    $(document).on('click','.shipping-protection_switch label', function(event) {
        event.preventDefault();
        console.log("Here")
        if (protectionCheckbox.prop('checked')) {
          console.log("Here checked")
            removeProtection(protectionVariantId);
        } else {
          console.log("Here unchecked")
            addProtection(protectionVariantId);
        }
    });
    
    function addProtection(variantId) {
      console.log("addProtection")
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { quantity: 1, id: variantId },
            dataType: 'json',
            success: function() {
                
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                      updates: {},
                      sections: ["cart-drawer", "cart-icon-bubble"]
                  })
              }).then((res) => res.json()).then((cartData) => {
                  document.querySelector("cart-drawer").renderContents(cartData); 
                   protectionCheckbox.prop('checked', true);
              });
            }
        });
    }
    
    function removeProtection(variantId) {
      console.log("removeProtection")
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: { updates: { [variantId]: 0 } },
            success: function() {
                 fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                      updates: {},
                      sections: ["cart-drawer", "cart-icon-bubble"]
                  })
              }).then((res) => res.json()).then((cartData) => {
                  document.querySelector("cart-drawer").renderContents(cartData); 
                   protectionCheckbox.prop('checked', false);
              });
            }
        });
    } 